var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _vm.loadingItemsWithNoExistingData
        ? [
            _c(
              "v-layout",
              [
                _c("v-progress-circular", {
                  staticClass: "mx-auto",
                  attrs: { size: "50", color: "info", indeterminate: "" },
                }),
              ],
              1
            ),
          ]
        : _vm._l(_vm.items.data, function (staticContentItem, i) {
            return _c("StaticContentItemTile", {
              key: `item-tile-${staticContentItem.Id}`,
              attrs: {
                value: staticContentItem,
                isFirst: _vm.isFirst(i),
                isLast: _vm.isLast(i),
                isEdit: _vm.isEdit,
                "tenant-name": _vm.tenantName,
              },
            })
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }